import type { SessionSettings } from '@/types/chat'

export interface StreamCompareHandlers {
  onMeta: (meta: { batch: CompareBatch }) => void
  onChunk: (modelResponseId: string, delta: string) => void
  onResponseDone: (result: {
    modelResponseId: string
    normalizedText: string
    tokensInput: number
    tokensOutput: number
    estimatedCost: number
    latencyMs: number
    status: string
    errorMessage?: string
  }) => void
  onDone: (compareBatchId: string) => void
  onError: (message: string) => void
}

export interface CompareRating {
  id: string
  modelResponseId: string
  ratingStars?: number
  thumbs?: 'up' | 'down'
  isBestAnswer: boolean
  comment?: string
  createdAt: string
}

export interface CompareResponse {
  modelResponseId: string
  sessionId: string
  model: { displayName: string; slug: string }
  provider: { name: string }
  category?: { name: string }
  modelId?: string
  categoryId?: string
  settingsSnapshot: SessionSettings
  settingsBadge: string
  normalizedText?: string
  tokensInput?: number
  tokensOutput?: number
  estimatedCost?: number
  latencyMs?: number
  status: string
  errorMessage?: string
  rating?: CompareRating | null
}

export interface CompareBatch {
  id: string
  title?: string
  promptText: string
  createdAt: string
  responses: CompareResponse[]
}

export interface CreateRatingRequest {
  modelResponseId: string
  ratingStars?: number
  thumbs?: 'up' | 'down'
  isBestAnswer?: boolean
  comment?: string
}

export interface RatingDto {
  id: string
  modelResponseId: string
  ratingStars?: number
  thumbs?: 'up' | 'down'
  isBestAnswer: boolean
  comment?: string
  createdAt: string
}

export const DEMO_COMPARE_BATCH_ID = 'batch-demo'
